import { Pipe, PipeTransform } from '@angular/core';

import { ContentPipe } from 'src/app/services/content/content.pipe';
import { CollaboratorsChip } from 'src/app/ai-assessments/dialogs/ai-assessment-share-dialog/interface/collaborator';
import { AssessmentInviteeStatusEnum } from 'src/app/api/models/assessments/assessment.enum';
import { AssessmentPage } from '../models/assessments.interface';

@Pipe({
	standalone: true,
	name: 'collaboratorsChip',
})
export class CollaboratorsChipPipe implements PipeTransform {
	constructor(private contentPipe: ContentPipe) {}

	transform(instance: AssessmentPage | Partial<AssessmentPage>, showCompletedOnly: boolean = false): CollaboratorsChip {
		if (!instance?.collabInvites?.length) {
			return null;
		}

		if (showCompletedOnly) {
			const count = instance.collabInvites.filter((invite) => invite.isDone).length;
			if (!count) {
				return null;
			}
			return {
				text: this.contentPipe.transform('ai-assessments-collaboration.doneBadge', { params: { count } }),
				backgroundColor: 'var(--mine-green)',
				textColor: 'var(--mine-blue-dark)',
				iconColor: 'rgba(0, 0, 0, 0.40)',
			};
		}

		const count = instance.collabInvites.filter(
			(invite) => !invite.isDone && invite.status !== AssessmentInviteeStatusEnum.Revoked,
		).length;
		if (!count) {
			return null;
		}
		return {
			text: this.contentPipe.transform('ai-assessments-collaboration.shareBadge', { params: { count } }),
			backgroundColor: 'var(--mine-grey-light-2)',
			textColor: 'var(--mine-blue-dark)',
			iconColor: 'var(--mine-grey-normal)',
		};
	}
}
